/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type - handles both Date objects and ISO strings */
  Date: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type AddBankAccountFailure = DomainError & {
  __typename?: 'AddBankAccountFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: AddBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `addBankAccount`. Stable across releases. No real members today — the mutation has no domain-decline path; the enum is kept as a stable slot for future declines. */
export type AddBankAccountFailureCode =
  | 'RESERVED';

/** Input for `addBankAccount`. Contains only the tokenized ACH metadata from Step 1 — the raw account and routing numbers never appear here. */
export type AddBankAccountInput = {
  /** Account type — CHECKING | SAVINGS | OTHER. */
  accountType: BankAccountType;
  /** Authorization transaction ID from `verifyBankAccountInformation`. */
  authTransactionId: Scalars['String']['input'];
  /** Bank name. Persisted to `ACHBankName__c`. */
  bankName: Scalars['String']['input'];
  /** Optional billing-address override for the saved account. Omit to leave blank — the read side then falls back to the member's Contact address. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** Token ID from `verifyBankAccountInformation`. Opaque to the caller. */
  gatewayTokenId: Scalars['String']['input'];
  /** True if this is an HSA account. Persisted to `HSACard__c`. */
  hsa: Scalars['Boolean']['input'];
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault: Scalars['Boolean']['input'];
  /** Last 5–6 digits of the account number, as a numeric string (e.g. `"123456"`). The full account number never appears here. */
  last6: Scalars['String']['input'];
  /** Name on the bank account. Persisted to `Name_on_Card__c`. */
  nameOnAccount: Scalars['String']['input'];
  /** The 9-digit ABA routing number (public bank data, not NPI). */
  routingLast9: Scalars['String']['input'];
  /** Source URL that originated the request. Max 500 characters. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Web/MD domain that originated the request. Max 100 characters. */
  webMdDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `addBankAccount` — Success on persisted account. Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. The Failure variant exists as a stable slot for future domain declines. */
export type AddBankAccountResult = AddBankAccountFailure | AddBankAccountSuccess;

/** Successful outcome of `addBankAccount`. Carries the persisted account as it now lives in Salesforce. */
export type AddBankAccountSuccess = {
  __typename?: 'AddBankAccountSuccess';
  /** The persisted `Payment_Profile__c` row mapped to the domain `SavedBankAccount` shape. */
  account: SavedBankAccount;
};

export type AddCreditCardFailure = DomainError & {
  __typename?: 'AddCreditCardFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: AddCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `addCreditCard`. Stable across releases. No real members today — the mutation has no domain-decline path; the enum is kept as a stable slot for future declines. */
export type AddCreditCardFailureCode =
  | 'RESERVED';

/** Input for `addCreditCard`. Contains only the tokenized card metadata from Step 1 — the PAN and CVV never appear here. */
export type AddCreditCardInput = {
  /** Optional affluence classification pass-through. */
  affluence?: InputMaybe<Scalars['String']['input']>;
  /** Authorization transaction ID from `verifyCreditCardInformation`. */
  authTransactionId: Scalars['String']['input'];
  /** Optional billing-address override for the saved card. Omit to leave blank — the read side then falls back to the member's Contact address. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** Card-type classification (COMMERCIAL | CONSUMER | UNKNOWN). Distinct from network. */
  cardType: CardType;
  /** Optional client-provided expiration marker (pass-through to `Expired__c`). */
  expired?: InputMaybe<Scalars['String']['input']>;
  /** Expiration month, 1–12. */
  expiryMonth: Scalars['Int']['input'];
  /** Expiration year as a 4-digit year (e.g. 2027). Combined with expiryMonth, the expiration must be in the current month or later. */
  expiryYear: Scalars['Int']['input'];
  /** Token ID from `verifyCreditCardInformation`. Opaque to the caller. */
  gatewayTokenId: Scalars['String']['input'];
  /** True if this card is HSA. Persisted to `HSACard__c`. */
  hsa: Scalars['Boolean']['input'];
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault: Scalars['Boolean']['input'];
  /** Issuer country code — pass-through into `Issuer_Country__c`. */
  issuerCountry?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of the card PAN, as a 4-character numeric string (e.g. `"1234"`). */
  last4: Scalars['String']['input'];
  /** Cardholder name as printed on the card. */
  nameOnCard?: InputMaybe<Scalars['String']['input']>;
  /** Card network — AMEX | VISA | MC | DISC. */
  network: CardNetwork;
  /** Optional prepaid-type classification pass-through. */
  prePaidType?: InputMaybe<Scalars['String']['input']>;
  /** Source URL that originated the request. Max 500 characters. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Web/MD domain that originated the request. Max 100 characters. */
  webMdDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `addCreditCard` — Success on persisted card. Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. The Failure variant exists as a stable slot for future domain declines. */
export type AddCreditCardResult = AddCreditCardFailure | AddCreditCardSuccess;

/** Successful outcome of `addCreditCard`. Carries the persisted card as it now lives in Salesforce. */
export type AddCreditCardSuccess = {
  __typename?: 'AddCreditCardSuccess';
  /** The persisted `Payment_Profile__c` row mapped to the domain `SavedCreditCard` shape. */
  card: SavedCreditCard;
};

/** Payment-method type returned by the FIS gateway for a tokenized bank account. */
export type BankAccountPaymentType =
  | 'ACH';

/** Bank-account type — CHECKING | SAVINGS | OTHER. Persisted to the SF `ACH_Name_of_Account__c` picklist. */
export type BankAccountType =
  | 'CHECKING'
  | 'OTHER'
  | 'SAVINGS';

/** Billing address composite. Returned as null if every underlying address field on the profile is blank. */
export type BillingAddress = {
  __typename?: 'BillingAddress';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of card issuance (from SF Issuer_Country__c). */
  country?: Maybe<Scalars['String']['output']>;
  /** Address line 1 (street). */
  line1?: Maybe<Scalars['String']['output']>;
  /** Address line 2 (apt, suite, etc.). */
  line2?: Maybe<Scalars['String']['output']>;
  /** State / region. */
  state?: Maybe<Scalars['String']['output']>;
  /** Postal / ZIP code. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Optional billing-address override for the saved card. When omitted, the SF address columns are left blank on create — the read side falls back to the member's Contact address at query time. */
export type BillingAddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address line 1 (street). */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 (apt, suite, etc.). */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** State / region. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Postal / ZIP code. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Supported credit-card networks returned by the FIS payment gateway. */
export type CardNetwork =
  | 'AMEX'
  | 'DISC'
  | 'MC'
  | 'VISA';

/** Card-type classification, distinct from network. `COMMERCIAL` / `CONSUMER` / `UNKNOWN`. Sourced from the gateway verify response. */
export type CardType =
  | 'COMMERCIAL'
  | 'CONSUMER'
  | 'UNKNOWN';

/** Common shape for typed domain-level failure variants in mutation results. Implementing types add their own typed `code` enum. */
export type DomainError = {
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

export type EditBankAccountFailure = DomainError & {
  __typename?: 'EditBankAccountFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: EditBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `editBankAccount`. Stable across releases — drives client dispatch. */
export type EditBankAccountFailureCode =
  | 'NOT_FOUND';

/** Input for `editBankAccount`. Every field optional — send only what you want to change. Routing / account digits and the gateway token are immutable and deliberately absent. */
export type EditBankAccountInput = {
  /** Account type — CHECKING | SAVINGS | OTHER. Persisted to `ACH_Name_of_Account__c`. */
  accountType?: InputMaybe<BankAccountType>;
  /** Bank name. Persisted to `ACHBankName__c`. */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** Optional billing-address override. When present, each sub-field is individually optional; omitted sub-fields leave that column unchanged in Salesforce. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** True if this is an HSA account. Persisted to `HSACard__c`. */
  hsa?: InputMaybe<Scalars['Boolean']['input']>;
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name on the bank account. Persisted to `Name_on_Card__c`. */
  nameOnAccount?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `editBankAccount` — Success on updated account, Failure on domain-level rejection (`NOT_FOUND`). Infrastructure and caller errors — including Zod validation failures — surface as GraphQL `errors`, not as result variants. */
export type EditBankAccountResult = EditBankAccountFailure | EditBankAccountSuccess;

/** Successful outcome of `editBankAccount`. Carries the updated account as it now lives in Salesforce after the PATCH + re-read. */
export type EditBankAccountSuccess = {
  __typename?: 'EditBankAccountSuccess';
  /** The updated `Payment_Profile__c` row mapped to the domain `SavedBankAccount` shape. */
  account: SavedBankAccount;
};

export type EditCreditCardFailure = DomainError & {
  __typename?: 'EditCreditCardFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: EditCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `editCreditCard`. Stable across releases — drives client dispatch. */
export type EditCreditCardFailureCode =
  | 'NOT_FOUND';

/** Input for `editCreditCard`. Every field optional — send only what you want to change. PAN, last-4, and gateway tokens are immutable and deliberately absent. */
export type EditCreditCardInput = {
  /** Optional affluence classification pass-through. */
  affluence?: InputMaybe<Scalars['String']['input']>;
  /** Optional billing-address override. When present, each sub-field is individually optional; omitted sub-fields leave that column unchanged in Salesforce. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** Card-type classification (COMMERCIAL | CONSUMER | UNKNOWN). */
  cardType?: InputMaybe<CardType>;
  /** Optional client-provided expiration marker (pass-through to `Expired__c`). */
  expired?: InputMaybe<Scalars['String']['input']>;
  /** Expiration month, 1–12. Must be provided together with `expiryYear`; the combined date must be in the future. */
  expiryMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Expiration year as a 4-digit year (e.g. 2027). Must be provided together with `expiryMonth`; the combined date must be in the future. */
  expiryYear?: InputMaybe<Scalars['Int']['input']>;
  /** True if this card is HSA. Persisted to `HSACard__c`. */
  hsa?: InputMaybe<Scalars['Boolean']['input']>;
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Issuer country code — pass-through into `Issuer_Country__c`. */
  issuerCountry?: InputMaybe<Scalars['String']['input']>;
  /** Cardholder name as printed on the card. */
  nameOnCard?: InputMaybe<Scalars['String']['input']>;
  /** Optional prepaid-type classification pass-through. */
  prePaidType?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `editCreditCard` — Success on updated card, Failure on domain-level rejection (`NOT_FOUND`). Infrastructure and caller errors — including Zod validation failures — surface as GraphQL `errors`, not as result variants. */
export type EditCreditCardResult = EditCreditCardFailure | EditCreditCardSuccess;

/** Successful outcome of `editCreditCard`. Carries the updated card as it now lives in Salesforce after the PATCH + re-read. */
export type EditCreditCardSuccess = {
  __typename?: 'EditCreditCardSuccess';
  /** The updated `Payment_Profile__c` row mapped to the domain `SavedCreditCard` shape. */
  card: SavedCreditCard;
};

export type EnableMyAutoPayFailure = DomainError & {
  __typename?: 'EnableMyAutoPayFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: EnableMyAutoPayFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `enableMyAutoPay`. Stable across releases — drives client dispatch. */
export type EnableMyAutoPayFailureCode =
  | 'ALREADY_ENABLED';

/** Typed outcome of `enableMyAutoPay` — Success on enrollment, Failure on domain-level rejection (`ALREADY_ENABLED`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type EnableMyAutoPayResult = EnableMyAutoPayFailure | EnableMyAutoPaySuccess;

/** Successful outcome of `enableMyAutoPay`. Carries the caller's member record as read at the pre-check, with `autoPay` projected to `true` to reflect the write. */
export type EnableMyAutoPaySuccess = {
  __typename?: 'EnableMyAutoPaySuccess';
  /** The caller's own Member record from the pre-check read, with `autoPay` set to `true` to reflect the AutoPay__c write. */
  member: Member;
};

/** The org-wide maximum amount a member may schedule for a single one-time payment. */
export type MaximumPaymentAmountType = {
  __typename?: 'MaximumPaymentAmountType';
  /** Maximum amount, in dollars. */
  amount: Scalars['Float']['output'];
  /** SF-admin-authored description of this configured maximum. */
  description: Scalars['String']['output'];
};

export type MeType = {
  __typename?: 'MeType';
  acceptingPatients?: Maybe<Scalars['Boolean']['output']>;
  connectUserId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  featureFlags?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labUserId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  messagingMailboxId?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  practiceId?: Maybe<Scalars['String']['output']>;
  practiceWebsite?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerImageUrl?: Maybe<Scalars['String']['output']>;
  sfUsername?: Maybe<Scalars['String']['output']>;
  userType: UserType;
};

export type Member = {
  __typename?: 'Member';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Persists a verified + tokenized bank account (ACH) to Salesforce and returns the saved account. */
  addBankAccount: AddBankAccountResult;
  /** Persists a verified + tokenized credit card to Salesforce and returns the saved card. */
  addCreditCard: AddCreditCardResult;
  /** Updates a saved bank account's metadata (bank name, account type, name on account, HSA flag, default, billing address). Routing / account digits and gateway tokens are immutable and cannot be edited. */
  editBankAccount: EditBankAccountResult;
  /** Updates a saved credit card's metadata (name, expiry, HSA flag, default, billing address, classifications). PAN and gateway tokens are immutable and cannot be edited. */
  editCreditCard: EditCreditCardResult;
  /** Enrolls the authenticated member in AutoPay, flipping their own Contact.AutoPay__c to true and Print_Invoice__c to false in Salesforce. */
  enableMyAutoPay: EnableMyAutoPayResult;
  /** Removes (soft-deletes via `Active__c = false`) a saved bank account (ACH) belonging to the authenticated member. Rejects removal of the current default — promote another payment method first. */
  removeBankAccount: RemoveBankAccountResult;
  /** Removes (soft-deletes via `Active__c = false`) a saved credit card belonging to the authenticated member. Rejects removal of the current default card — promote another card first. */
  removeCreditCard: RemoveCreditCardResult;
  /** Schedules a one-time payment toward the authenticated member's balance. */
  scheduleOneTimePayment: ScheduleOneTimePaymentResult;
  /** Sets any active, owned payment method (credit card or bank account) as the authenticated member's default. */
  setDefaultPaymentMethod: SetDefaultPaymentMethodResult;
  /** Verifies bank-account (ACH) information with the payment gateway. */
  verifyBankAccountInformation: VerifyBankAccountInformationResult;
  /** Verifies credit card information with the payment gateway. */
  verifyCreditCardInformation: VerifyCreditCardInformationResult;
};


export type MutationAddBankAccountArgs = {
  input: AddBankAccountInput;
};


export type MutationAddCreditCardArgs = {
  input: AddCreditCardInput;
};


export type MutationEditBankAccountArgs = {
  id: Scalars['ID']['input'];
  input: EditBankAccountInput;
};


export type MutationEditCreditCardArgs = {
  id: Scalars['ID']['input'];
  input: EditCreditCardInput;
};


export type MutationRemoveBankAccountArgs = {
  input: RemoveBankAccountInput;
};


export type MutationRemoveCreditCardArgs = {
  input: RemoveCreditCardInput;
};


export type MutationScheduleOneTimePaymentArgs = {
  input: ScheduleOneTimePaymentInput;
};


export type MutationSetDefaultPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVerifyBankAccountInformationArgs = {
  input: VerifyBankAccountInput;
};


export type MutationVerifyCreditCardInformationArgs = {
  input: VerifyCreditCardInformationInput;
};

export type MyFeatureFlagsType = {
  __typename?: 'MyFeatureFlagsType';
  AWPAudit__c: Scalars['Boolean']['output'];
  AWPCreate__c: Scalars['Boolean']['output'];
  AWPManage__c: Scalars['Boolean']['output'];
  AWPPlus__c: Scalars['Boolean']['output'];
  AWPRead__c: Scalars['Boolean']['output'];
  AcceptingJuniorMembers__c: Scalars['Boolean']['output'];
  AnalyticsReport__c: Scalars['Boolean']['output'];
  ApparelandMerchandise__c: Scalars['Boolean']['output'];
  Cardiology__c: Scalars['Boolean']['output'];
  CollateralandStationary__c: Scalars['Boolean']['output'];
  Endocrinology__c: Scalars['Boolean']['output'];
  EventsandMarketingMaterials__c: Scalars['Boolean']['output'];
  FinancialReports__c: Scalars['Boolean']['output'];
  Foundation__c: Scalars['Boolean']['output'];
  MCEReferrals__c: Scalars['Boolean']['output'];
  MDVIPWebmail__c: Scalars['Boolean']['output'];
  ManageCHL__c: Scalars['Boolean']['output'];
  ManageGroupPractice__c: Scalars['Boolean']['output'];
  ManageOfficeHours__c: Scalars['Boolean']['output'];
  ManagePayments__c: Scalars['Boolean']['output'];
  ManagePortalUser__c: Scalars['Boolean']['output'];
  MedicalResources__c: Scalars['Boolean']['output'];
  MemberSatisfaction__c: Scalars['Boolean']['output'];
  MensHealth__c: Scalars['Boolean']['output'];
  MyEvents__c: Scalars['Boolean']['output'];
  MyInitiatives__c: Scalars['Boolean']['output'];
  MyWaitinglist__c: Scalars['Boolean']['output'];
  Notifications__c: Scalars['Boolean']['output'];
  OfficeDepotOfficeMax__c: Scalars['Boolean']['output'];
  Patients__c: Scalars['Boolean']['output'];
  Pediatric__c: Scalars['Boolean']['output'];
  Programs__c: Scalars['Boolean']['output'];
  Prospects__c: Scalars['Boolean']['output'];
  ReciprocityVisit__c: Scalars['Boolean']['output'];
  SecureMessaging__c: Scalars['Boolean']['output'];
  SecureMsg_Read_Only__c: Scalars['Boolean']['output'];
  Staplesdotcom__c: Scalars['Boolean']['output'];
  ToDos__c: Scalars['Boolean']['output'];
  ValueBasedCare__c: Scalars['Boolean']['output'];
  WomensHealth__c: Scalars['Boolean']['output'];
};

export type MyPaymentPlanFailure = DomainError & {
  __typename?: 'MyPaymentPlanFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: MyPaymentPlanFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `myPaymentPlan`. Stable across releases — drives client dispatch. */
export type MyPaymentPlanFailureCode =
  | 'NO_ACTIVE_PAYMENT_PLAN';

/** Typed outcome of `myPaymentPlan` — Success with the caller's plan details, Failure when no active payment plan exists (`NO_ACTIVE_PAYMENT_PLAN`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type MyPaymentPlanResult = MyPaymentPlanFailure | MyPaymentPlanSuccess;

/** Successful outcome of `myPaymentPlan`. Carries the caller's billing cadence and annual membership fee. */
export type MyPaymentPlanSuccess = {
  __typename?: 'MyPaymentPlanSuccess';
  /** Annual membership fee. */
  annualTotal: Scalars['Float']['output'];
  /** Billing cadence, e.g. "Quarterly". */
  cadence: Scalars['String']['output'];
};

/** Pagination + filter options for `myPaymentTransactions`. All fields optional — see Zod schema for defaults. */
export type MyPaymentTransactionsInput = {
  /** Pagination — max records to return. Defaults to 25, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination — number of records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Transaction types to include. Defaults to [PAYMENT] only — matches legacy's default filter, excluding Refund/Payment Reversal/Credit Memo unless explicitly widened. */
  types?: InputMaybe<Array<TransactionType>>;
};

/** A page of the authenticated member's payment transactions. */
export type MyPaymentTransactionsSuccess = {
  __typename?: 'MyPaymentTransactionsSuccess';
  /** Transactions in this page, sorted by date descending (most recent first). */
  edges: Array<PaymentTransaction>;
  /** Post-filter count for this page: number of transactions in `edges` after per-row parse failures are dropped. Equal to `edges.length`. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Pre-filter count: total transactions matching the SOQL `WHERE` clause across all pages (sourced from a parallel SOQL `SELECT COUNT()` query — see service). */
  totalCount: Scalars['Int']['output'];
};

export type MyPermissionsType = {
  __typename?: 'MyPermissionsType';
  rules: Scalars['JSON']['output'];
};

export type MySavedPaymentMethodsFailure = DomainError & {
  __typename?: 'MySavedPaymentMethodsFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: MySavedPaymentMethodsFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `mySavedPaymentMethods`. Stable across releases — drives client dispatch. */
export type MySavedPaymentMethodsFailureCode =
  | 'INVALID_INPUT';

/** Pagination + filter options for `mySavedPaymentMethods`. All fields optional — see Zod schema for defaults. */
export type MySavedPaymentMethodsInput = {
  /** When true, include expired payment methods (today: credit cards only). Defaults to true — the UI groups them under 'Expired'. */
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, include inactive (deactivated) payment methods. Defaults to false. */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pagination — max records to return. Defaults to 25, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination — number of records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Typed outcome of `mySavedPaymentMethods` — Success on a returned page, Failure on a domain-level rejection. Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type MySavedPaymentMethodsResult = MySavedPaymentMethodsFailure | MySavedPaymentMethodsSuccess;

/** Successful page of the authenticated member's saved payment methods. */
export type MySavedPaymentMethodsSuccess = {
  __typename?: 'MySavedPaymentMethodsSuccess';
  /** Payment methods in this page. Each element is one of the `SavedPaymentMethod` variants — `SavedCreditCard` or `SavedBankAccount` (ACH) today; digital-wallet variants are planned. */
  edges: Array<SavedPaymentMethod>;
  /** Post-filter count for this page: number of cards in `edges` after the API drops expired cards when `includeExpired=false` (or per-row parse failures). Equal to `edges.length`. When `includeExpired=true` (default) and no rows are parse-dropped, `filteredCount` equals the SOQL row count for this page. Reliable pagination stop condition: `offset + limit >= totalCount` — do NOT use `edges.length < limit`, which can trigger early when includeExpired=false drops rows mid-stream. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Pre-filter count: total payment-method profiles matching the SOQL `WHERE` clause across all pages (sourced from a parallel SOQL `SELECT COUNT()` query — see service). When `includeExpired=false`, this is the pre-expiry-drop total — use `filteredCount` (this page) for the actual cards returned, not `totalCount / limit` rounded up. */
  totalCount: Scalars['Int']['output'];
};

/** The authenticated member's next scheduled payment. Sourced from Jitterbit — no Salesforce object behind it. */
export type NextPaymentDueType = {
  __typename?: 'NextPaymentDueType';
  /** Amount of the next scheduled payment. `0` when none is currently scheduled; `null` only when Jitterbit omits the amount or it is unparseable. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Due date of the next scheduled payment, ISO `yyyy-MM-dd`. Null when none is currently scheduled. */
  dueDate?: Maybe<Scalars['String']['output']>;
};

/** Kind of payment method behind a transaction's account. UNKNOWN means a payment profile is linked but carries neither a recognizable card brand nor bank info — a data-integrity gap, not a normal state. */
export type PaymentAccountKind =
  | 'BANK'
  | 'CARD'
  | 'CHECK'
  | 'REMOVED'
  | 'UNKNOWN';

/** A single payment transaction on the authenticated member's history. Sourced from Salesforce `Transactions__c`. */
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  /** Classification of the payment method behind this transaction. */
  accountKind: PaymentAccountKind;
  /** Trailing digits identifying the account — `CCLast4__c` for `CARD`, `ACHLast6__c` for `BANK`. Length varies by kind; null for `CHECK`/`REMOVED`/`UNKNOWN`. */
  accountSuffix?: Maybe<Scalars['String']['output']>;
  /** Transaction amount (e.g. 1234.56). */
  amount: Scalars['Float']['output'];
  /** Bank name for the linked account, sourced from `ACHBankName__c`. Present only when `accountKind` is `BANK`. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Transaction date, ISO `yyyy-MM-dd` (Salesforce `Apply_Date__c`). */
  date: Scalars['String']['output'];
  /** Expiration month, 1–12. Present only when `accountKind` is `CARD`. */
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  /** Expiration year. Present only when `accountKind` is `CARD`. */
  expirationYear?: Maybe<Scalars['Int']['output']>;
  /** Salesforce `Transactions__c` record ID. */
  id: Scalars['ID']['output'];
  /** Card network, present only when `accountKind` is `CARD`. Null when the brand value on the linked profile isn't a recognized network — the row is still returned, never dropped. */
  network?: Maybe<CardNetwork>;
  /** Transaction type. */
  type: TransactionType;
};

/** A postal address. Null when the member has no address on file; individual fields are null when blank. */
export type PostalAddress = {
  __typename?: 'PostalAddress';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country. */
  country?: Maybe<Scalars['String']['output']>;
  /** Street address, first line. */
  line1?: Maybe<Scalars['String']['output']>;
  /** Street address, second line (suite, apt, etc.). */
  line2?: Maybe<Scalars['String']['output']>;
  /** State / region. */
  state?: Maybe<Scalars['String']['output']>;
  /** Postal / ZIP code. */
  zip?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns the org-wide maximum amount for a single one-time payment. */
  maximumPaymentAmount: MaximumPaymentAmountType;
  /** Returns the enriched session profile for the authenticated user */
  me: MeType;
  /** Returns a member by Salesforce Contact Id. Provider/staff only, scoped to their own practice — members must use myMemberInfo. */
  memberInfoByContactId?: Maybe<Member>;
  /** Returns the authenticated user's own feature flags. */
  myFeatureFlags: MyFeatureFlagsType;
  /** Returns the authenticated member's own record. */
  myMemberInfo?: Maybe<Member>;
  /** Returns the authenticated member's next scheduled payment. */
  myNextPaymentDue: NextPaymentDueType;
  /** Returns the authenticated member's billing cadence and annual membership fee, or a typed failure when no active payment plan exists. */
  myPaymentPlan: MyPaymentPlanResult;
  /** Returns the authenticated member's payment transaction history. */
  myPaymentTransactions: MyPaymentTransactionsSuccess;
  /** Returns packed CASL rules for the authenticated user. Hydrate client-side with createMongoAbility(rules). */
  myPermissions: MyPermissionsType;
  /** Returns the authenticated member's saved payment methods. */
  mySavedPaymentMethods: MySavedPaymentMethodsResult;
  /** Returns the authenticated member's scheduled future one-time payments. */
  myUpcomingPayments: Array<UpcomingPayment>;
};


export type QueryMemberInfoByContactIdArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryMyPaymentTransactionsArgs = {
  input: MyPaymentTransactionsInput;
};


export type QueryMySavedPaymentMethodsArgs = {
  input: MySavedPaymentMethodsInput;
};

export type RemoveBankAccountFailure = DomainError & {
  __typename?: 'RemoveBankAccountFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: RemoveBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `removeBankAccount`. Stable across releases — drives client dispatch. */
export type RemoveBankAccountFailureCode =
  | 'DEFAULT_ACCOUNT'
  | 'NOT_FOUND';

/** Input for `removeBankAccount`. Contains only the target `Payment_Profile__c` record ID — ownership is enforced from the JWT-derived session, never from client input. */
export type RemoveBankAccountInput = {
  /** Salesforce `Payment_Profile__c` record ID of the bank account to remove. Must belong to the authenticated member, must be an ACH profile, and must not be the current default. */
  id: Scalars['ID']['input'];
};

/** Typed outcome of `removeBankAccount` — Success on soft-deleted account, Failure on domain-level rejection (NOT_FOUND / DEFAULT_ACCOUNT). Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type RemoveBankAccountResult = RemoveBankAccountFailure | RemoveBankAccountSuccess;

/** Successful outcome of `removeBankAccount`. Carries the removed account as it now lives in Salesforce (with `isActive = false`). */
export type RemoveBankAccountSuccess = {
  __typename?: 'RemoveBankAccountSuccess';
  /** The removed `Payment_Profile__c` row mapped to the domain `SavedBankAccount` shape. `isActive` will be `false`. */
  account: SavedBankAccount;
};

export type RemoveCreditCardFailure = DomainError & {
  __typename?: 'RemoveCreditCardFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: RemoveCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `removeCreditCard`. Stable across releases — drives client dispatch. */
export type RemoveCreditCardFailureCode =
  | 'DEFAULT_CARD'
  | 'NOT_FOUND';

/** Input for `removeCreditCard`. Contains only the target `Payment_Profile__c` record ID — ownership is enforced from the JWT-derived session, never from client input. */
export type RemoveCreditCardInput = {
  /** Salesforce `Payment_Profile__c` record ID of the credit card to remove. Must belong to the authenticated member and must not be the current default. */
  id: Scalars['ID']['input'];
};

/** Typed outcome of `removeCreditCard` — Success on soft-deleted card, Failure on domain-level rejection (NOT_FOUND / DEFAULT_CARD). Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type RemoveCreditCardResult = RemoveCreditCardFailure | RemoveCreditCardSuccess;

/** Successful outcome of `removeCreditCard`. Carries the removed card as it now lives in Salesforce (with `isActive = false`). */
export type RemoveCreditCardSuccess = {
  __typename?: 'RemoveCreditCardSuccess';
  /** The removed `Payment_Profile__c` row mapped to the domain `SavedCreditCard` shape. `isActive` will be `false`. */
  card: SavedCreditCard;
};

/** Bank-account (ACH) variant of `SavedPaymentMethod`. Sourced from `Payment_Profile__c` rows where `PaymentType__c = 'ACH'`. The full account and routing numbers never leave the payment gateway — only the masked `last6` and the (public) 9-digit routing number are stored and returned. */
export type SavedBankAccount = SavedPaymentMethod & {
  __typename?: 'SavedBankAccount';
  /** Account type — CHECKING | SAVINGS | OTHER (from `ACH_Name_of_Account__c`). */
  accountType: BankAccountType;
  /** Bank name as captured at add time (from `ACHBankName__c`). Null when the SF column is blank — `addBankAccount` always sets it, but legacy or externally-created rows may not. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing address on file. Null when every address field on the profile is blank. */
  billingAddress?: Maybe<BillingAddress>;
  /** Salesforce `Payment_Profile__c` record ID. */
  id: Scalars['ID']['output'];
  /** True if the profile is active (not deactivated) in Salesforce. */
  isActive: Scalars['Boolean']['output'];
  /** True if this payment method is enrolled in autopay. Currently returns `false` as a placeholder — see CNP-169 §6 Q2. */
  isAutoPay: Scalars['Boolean']['output'];
  /** True if this is the member's default payment method. */
  isDefault: Scalars['Boolean']['output'];
  /** True if the account is flagged as an HSA account on the profile. */
  isHSA: Scalars['Boolean']['output'];
  /** Last 5–6 digits of the bank account number (from `ACHLast6__c`). The client owns presentation — render `••••{last6}`, `…1234`, etc. The full account number never leaves the payment gateway. */
  last6: Scalars['String']['output'];
  /** Name on the bank account, if stored (from `Name_on_Card__c`). */
  nameOnAccount?: Maybe<Scalars['String']['output']>;
  /** The 9-digit ABA routing number (from `ACHRoutingLast9__c`). Public bank data, not account-identifying on its own. */
  routingLast9: Scalars['String']['output'];
};

/** Credit-card variant of `SavedPaymentMethod`. Sourced from `Payment_Profile__c` rows where `PaymentType__c ∈ {AMEX, VISA, MC, DISC}`. */
export type SavedCreditCard = SavedPaymentMethod & {
  __typename?: 'SavedCreditCard';
  /** Billing address on file. Null when every address field on the profile is blank. */
  billingAddress?: Maybe<BillingAddress>;
  /** Expiration month, 1–12. */
  expirationMonth: Scalars['Int']['output'];
  /** Expiration year as a 4-digit year (e.g. 2027). */
  expirationYear: Scalars['Int']['output'];
  /** Salesforce `Payment_Profile__c` record ID. */
  id: Scalars['ID']['output'];
  /** True if the profile is active (not deactivated) in Salesforce. */
  isActive: Scalars['Boolean']['output'];
  /** True if this payment method is enrolled in autopay. Currently returns `false` as a placeholder — see CNP-169 §6 Q2. */
  isAutoPay: Scalars['Boolean']['output'];
  /** True if this is the member's default payment method. */
  isDefault: Scalars['Boolean']['output'];
  /** Derived in API from the current UTC year-month — a card is expired only AFTER the last day of its printed expiry month. */
  isExpired: Scalars['Boolean']['output'];
  /** True if the card is flagged as an FSA card. Currently returns `false` as a placeholder — see CNP-169 §6 Q1. */
  isFSA: Scalars['Boolean']['output'];
  /** True if the card is flagged as an HSA card on the profile. */
  isHSA: Scalars['Boolean']['output'];
  /** Last 4 digits of the card PAN, as a 4-character numeric string (e.g. `"1234"`). The client owns presentation — render `•••• •••• •••• {last4}`, `…1234`, etc. The full PAN never leaves the payment gateway. */
  last4: Scalars['String']['output'];
  /** Cardholder name as it appears on the card, if stored. */
  nameOnCard?: Maybe<Scalars['String']['output']>;
  /** Card network — AMEX | VISA | MC | DISC. */
  network: CardNetwork;
};

/** A single saved payment method on file for the authenticated member. Variant-agnostic shape. Implemented by `SavedCreditCard` and `SavedBankAccount` (ACH); digital-wallet variants are planned. Sourced from Salesforce `Payment_Profile__c`. */
export type SavedPaymentMethod = {
  /** Billing address on file. Null when every address field on the profile is blank. */
  billingAddress?: Maybe<BillingAddress>;
  /** Salesforce `Payment_Profile__c` record ID. */
  id: Scalars['ID']['output'];
  /** True if the profile is active (not deactivated) in Salesforce. */
  isActive: Scalars['Boolean']['output'];
  /** True if this payment method is enrolled in autopay. Currently returns `false` as a placeholder — see CNP-169 §6 Q2. */
  isAutoPay: Scalars['Boolean']['output'];
  /** True if this is the member's default payment method. */
  isDefault: Scalars['Boolean']['output'];
};

export type ScheduleOneTimePaymentFailure = DomainError & {
  __typename?: 'ScheduleOneTimePaymentFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: ScheduleOneTimePaymentFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `scheduleOneTimePayment`. Stable across releases — drives client dispatch. */
export type ScheduleOneTimePaymentFailureCode =
  | 'AMOUNT_EXCEEDS_MAXIMUM'
  | 'NOT_FOUND';

/** Input for `scheduleOneTimePayment` — schedules a one-time payment toward the member's balance. */
export type ScheduleOneTimePaymentInput = {
  /** Payment amount. Must be greater than 0. */
  amount: Scalars['Float']['input'];
  /** The selected saved payment account's `Payment_Profile__c` id. */
  paymentProfileId: Scalars['ID']['input'];
  /** ISO `yyyy-MM-dd` date the payment should be processed. Must be strictly after today in America/New_York. */
  scheduleDate: Scalars['String']['input'];
  /** Optional origin URL pass-through. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional origin domain pass-through. */
  webMdDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `scheduleOneTimePayment` — Success on the created record, Failure on domain-level rejection (`NOT_FOUND`, `AMOUNT_EXCEEDS_MAXIMUM`). Infrastructure and caller errors — including Zod validation failures — surface as GraphQL `errors`, not as result variants. */
export type ScheduleOneTimePaymentResult = ScheduleOneTimePaymentFailure | ScheduleOneTimePaymentSuccess;

/** Successful outcome of `scheduleOneTimePayment`. Carries the created Transaction_Queue__c record's identity. */
export type ScheduleOneTimePaymentSuccess = {
  __typename?: 'ScheduleOneTimePaymentSuccess';
  /** The created `Transaction_Queue__c` record's id. */
  id: Scalars['ID']['output'];
  /** The created `Transaction_Queue__c` record's name. */
  name: Scalars['String']['output'];
};

export type SetDefaultPaymentMethodFailure = DomainError & {
  __typename?: 'SetDefaultPaymentMethodFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: SetDefaultPaymentMethodFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `setDefaultPaymentMethod`. Stable across releases — drives client dispatch. */
export type SetDefaultPaymentMethodFailureCode =
  | 'NOT_FOUND';

/** Typed outcome of `setDefaultPaymentMethod` — Success on the record now flagged default, Failure on domain-level rejection (`NOT_FOUND`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type SetDefaultPaymentMethodResult = SetDefaultPaymentMethodFailure | SetDefaultPaymentMethodSuccess;

/** Successful outcome of `setDefaultPaymentMethod`. No re-read — the input id and the fact that the PATCH didn't throw are sufficient to report `isDefault: true`. */
export type SetDefaultPaymentMethodSuccess = {
  __typename?: 'SetDefaultPaymentMethodSuccess';
  /** Salesforce `Payment_Profile__c` record ID that was set default. */
  id: Scalars['ID']['output'];
  /** Always `true` on success. */
  isDefault: Scalars['Boolean']['output'];
};

/** Domain transaction type — PAYMENT | PAYMENT_REVERSAL | CREDIT_MEMO | REFUND. Mapped from the Salesforce `Type__c` picklist; no `__c` past the mapper. */
export type TransactionType =
  | 'CREDIT_MEMO'
  | 'PAYMENT'
  | 'PAYMENT_REVERSAL'
  | 'REFUND';

/** A single scheduled future one-time payment on the authenticated member's account. Sourced from Salesforce `Transaction_Queue__c`. */
export type UpcomingPayment = {
  __typename?: 'UpcomingPayment';
  /** Classification of the payment method behind this scheduled payment. */
  accountKind: PaymentAccountKind;
  /** Trailing digits identifying the account — `CCLast4__c` for `CARD`, `ACHLast6__c` for `BANK`. Length varies by kind; null for `CHECK`/`REMOVED`/`UNKNOWN`. */
  accountSuffix?: Maybe<Scalars['String']['output']>;
  /** Payment amount (e.g. 750.00). */
  amount: Scalars['Float']['output'];
  /** Bank name for the linked account, sourced from `ACHBankName__c`. Present only when `accountKind` is `BANK`. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Expiration month, 1–12. Present only when `accountKind` is `CARD`. */
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  /** Expiration year. Present only when `accountKind` is `CARD`. */
  expirationYear?: Maybe<Scalars['Int']['output']>;
  /** Salesforce `Transaction_Queue__c` record ID. */
  id: Scalars['ID']['output'];
  /** Card network, present only when `accountKind` is `CARD`. Null when the brand value on the linked profile isn't a recognized network — the row is still returned, never dropped. */
  network?: Maybe<CardNetwork>;
  /** Salesforce `Payment_Profile__c` record ID this payment is scheduled against, when linked (null for a `REMOVED` row). Not guaranteed to have a matching row in `mySavedPaymentMethods` — that query's own filters and pagination can exclude a profile that appears here. Callers must treat 'no match found' as expected, not an error. */
  paymentProfileId?: Maybe<Scalars['ID']['output']>;
  /** Estimated payment date, ISO `yyyy-MM-dd` (Salesforce `Schedule_Date__c`). */
  scheduledDate: Scalars['String']['output'];
  /** Status of the scheduled payment. */
  status: UpcomingPaymentStatus;
};

/** Status of a scheduled upcoming payment. UNKNOWN means the Salesforce status value didn't map to a known member — a data-integrity gap, not a normal state. */
export type UpcomingPaymentStatus =
  | 'PENDING_PROCESSING'
  | 'RESCHEDULED_CHARGE_REJECTED'
  | 'SCHEDULED'
  | 'UNKNOWN';

/** The type of user in the system */
export type UserType =
  | 'MEMBER'
  | 'PROVIDER'
  | 'STAFF';

/** Machine-readable failure category for `verifyBankAccountInformation`. Stable across releases — drives client dispatch. */
export type VerifyBankAccountFailureCode =
  | 'DECLINED'
  | 'UNSUPPORTED_ACCOUNT';

export type VerifyBankAccountInformationFailure = DomainError & {
  __typename?: 'VerifyBankAccountInformationFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: VerifyBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Typed outcome of `verifyBankAccountInformation` — Success on tokenization, Failure on decline or unsupported account. Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type VerifyBankAccountInformationResult = VerifyBankAccountInformationFailure | VerifyBankAccountInformationSuccess;

export type VerifyBankAccountInformationSuccess = {
  __typename?: 'VerifyBankAccountInformationSuccess';
  /** Authorization transaction ID returned by the gateway. */
  authTransactionId: Scalars['String']['output'];
  /** Token ID returned by the payment gateway for the verified bank account. */
  gatewayTokenId: Scalars['String']['output'];
  /** Payment-method type of the tokenized account. Always `ACH` on this path. */
  paymentType: BankAccountPaymentType;
};

export type VerifyBankAccountInput = {
  /** Bank account number — 4 to 17 digits. Embedded whitespace is stripped at the boundary. Never persisted or returned. */
  accountNumber: Scalars['String']['input'];
  /** ABA routing number — 9 digits with a valid check digit. Embedded whitespace is stripped at the boundary. */
  routingNumber: Scalars['String']['input'];
};

/** Machine-readable failure category for `verifyCreditCardInformation`. Stable across releases — drives client dispatch. */
export type VerifyCreditCardFailureCode =
  | 'DECLINED'
  | 'UNSUPPORTED_NETWORK';

export type VerifyCreditCardInformationFailure = DomainError & {
  __typename?: 'VerifyCreditCardInformationFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: VerifyCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

export type VerifyCreditCardInformationInput = {
  /** Card verification value. 3 digits for most networks; 4 digits for AMEX. */
  CVV: Scalars['String']['input'];
  /** Credit card number. AMEX (BINs 34/37) is 15 digits; all other networks are 16 digits. Embedded whitespace is stripped at the boundary. */
  CardNumber: Scalars['String']['input'];
  /** Expiration month, 1–12. */
  ExpirationMonth: Scalars['Int']['input'];
  /** Expiration year as a 4-digit year (e.g. 2027). Combined with ExpirationMonth, the expiration must be in the current month or later. */
  ExpirationYear: Scalars['Int']['input'];
};

/** Typed outcome of `verifyCreditCardInformation` — Success on tokenization, Failure on decline or unsupported network. Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type VerifyCreditCardInformationResult = VerifyCreditCardInformationFailure | VerifyCreditCardInformationSuccess;

export type VerifyCreditCardInformationSuccess = {
  __typename?: 'VerifyCreditCardInformationSuccess';
  /** Authorization transaction ID returned by the gateway. */
  authTransactionId: Scalars['String']['output'];
  /** Token ID returned by the payment gateway for the verified credit card. */
  gatewayTokenId: Scalars['String']['output'];
  /** Card network determined by the gateway response (AMEX | VISA | MC | DISC). */
  network: CardNetwork;
};

export type EnableMyAutoPayMutationVariables = Exact<{ [key: string]: never; }>;


export type EnableMyAutoPayMutation = { __typename?: 'Mutation', enableMyAutoPay:
    | { __typename: 'EnableMyAutoPayFailure', code: EnableMyAutoPayFailureCode }
    | { __typename: 'EnableMyAutoPaySuccess', member: { __typename?: 'Member', autoPay?: boolean | null } }
   };

export type MyMemberInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MyMemberInfoQuery = { __typename?: 'Query', myMemberInfo?: { __typename?: 'Member', id: string, firstName?: string | null, lastName?: string | null, autoPay?: boolean | null, currentBalanceFormula?: number | null, currentAgreementPaymentSchedule?: string | null, dateOfOldestUnpaidInvoice?: string | null, billingDaysPastDue?: number | null, mailingAddress?: { __typename?: 'PostalAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null };

export type AddBankAccountMutationVariables = Exact<{
  input: AddBankAccountInput;
}>;


export type AddBankAccountMutation = { __typename?: 'Mutation', addBankAccount:
    | { __typename: 'AddBankAccountFailure', code: AddBankAccountFailureCode }
    | { __typename: 'AddBankAccountSuccess', account: { __typename?: 'SavedBankAccount', id: string } }
   };

export type AddCreditCardMutationVariables = Exact<{
  input: AddCreditCardInput;
}>;


export type AddCreditCardMutation = { __typename?: 'Mutation', addCreditCard:
    | { __typename: 'AddCreditCardFailure', code: AddCreditCardFailureCode }
    | { __typename: 'AddCreditCardSuccess', card: { __typename?: 'SavedCreditCard', id: string } }
   };

export type EditBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EditBankAccountInput;
}>;


export type EditBankAccountMutation = { __typename?: 'Mutation', editBankAccount:
    | { __typename: 'EditBankAccountFailure', code: EditBankAccountFailureCode }
    | { __typename: 'EditBankAccountSuccess', account: { __typename?: 'SavedBankAccount', id: string, isDefault: boolean, isActive: boolean, last6: string, bankName?: string | null, accountType: BankAccountType, nameOnAccount?: string | null, isHSA: boolean, billingAddress?: { __typename?: 'BillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } }
   };

export type EditCreditCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EditCreditCardInput;
}>;


export type EditCreditCardMutation = { __typename?: 'Mutation', editCreditCard:
    | { __typename: 'EditCreditCardFailure', code: EditCreditCardFailureCode }
    | { __typename: 'EditCreditCardSuccess', card: { __typename?: 'SavedCreditCard', id: string, isDefault: boolean, isActive: boolean, last4: string, network: CardNetwork, nameOnCard?: string | null, expirationMonth: number, expirationYear: number, isExpired: boolean, isHSA: boolean, billingAddress?: { __typename?: 'BillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } }
   };

export type MaximumPaymentAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type MaximumPaymentAmountQuery = { __typename?: 'Query', maximumPaymentAmount: { __typename?: 'MaximumPaymentAmountType', amount: number, description: string } };

export type MyNextPaymentDueQueryVariables = Exact<{ [key: string]: never; }>;


export type MyNextPaymentDueQuery = { __typename?: 'Query', myNextPaymentDue: { __typename?: 'NextPaymentDueType', amount?: number | null, dueDate?: string | null } };

export type MyPaymentTransactionsQueryVariables = Exact<{
  input: MyPaymentTransactionsInput;
}>;


export type MyPaymentTransactionsQuery = { __typename?: 'Query', myPaymentTransactions: { __typename?: 'MyPaymentTransactionsSuccess', offset: number, limit: number, totalCount: number, filteredCount: number, edges: Array<{ __typename?: 'PaymentTransaction', id: string, amount: number, date: string, type: TransactionType, accountKind: PaymentAccountKind, network?: CardNetwork | null, accountSuffix?: string | null, bankName?: string | null, expirationMonth?: number | null, expirationYear?: number | null }> } };

export type MySavedPaymentMethodsQueryVariables = Exact<{
  input: MySavedPaymentMethodsInput;
}>;


export type MySavedPaymentMethodsQuery = { __typename?: 'Query', mySavedPaymentMethods:
    | { __typename: 'MySavedPaymentMethodsFailure', code: MySavedPaymentMethodsFailureCode }
    | { __typename: 'MySavedPaymentMethodsSuccess', edges: Array<
        | { __typename: 'SavedBankAccount', last6: string, bankName?: string | null, accountType: BankAccountType, nameOnAccount?: string | null, isHSA: boolean, id: string, isDefault: boolean, isActive: boolean, billingAddress?: { __typename?: 'BillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }
        | { __typename: 'SavedCreditCard', last4: string, network: CardNetwork, nameOnCard?: string | null, expirationMonth: number, expirationYear: number, isExpired: boolean, isHSA: boolean, id: string, isDefault: boolean, isActive: boolean, billingAddress?: { __typename?: 'BillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }
      > }
   };

export type MyUpcomingPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUpcomingPaymentsQuery = { __typename?: 'Query', myUpcomingPayments: Array<{ __typename?: 'UpcomingPayment', id: string, paymentProfileId?: string | null, scheduledDate: string, amount: number, accountKind: PaymentAccountKind, network?: CardNetwork | null, accountSuffix?: string | null, expirationMonth?: number | null, expirationYear?: number | null, bankName?: string | null }> };

export type RemoveBankAccountMutationVariables = Exact<{
  input: RemoveBankAccountInput;
}>;


export type RemoveBankAccountMutation = { __typename?: 'Mutation', removeBankAccount:
    | { __typename: 'RemoveBankAccountFailure', code: RemoveBankAccountFailureCode }
    | { __typename: 'RemoveBankAccountSuccess', account: { __typename?: 'SavedBankAccount', id: string } }
   };

export type RemoveCreditCardMutationVariables = Exact<{
  input: RemoveCreditCardInput;
}>;


export type RemoveCreditCardMutation = { __typename?: 'Mutation', removeCreditCard:
    | { __typename: 'RemoveCreditCardFailure', code: RemoveCreditCardFailureCode }
    | { __typename: 'RemoveCreditCardSuccess', card: { __typename?: 'SavedCreditCard', id: string } }
   };

export type ScheduleOneTimePaymentMutationVariables = Exact<{
  input: ScheduleOneTimePaymentInput;
}>;


export type ScheduleOneTimePaymentMutation = { __typename?: 'Mutation', scheduleOneTimePayment:
    | { __typename: 'ScheduleOneTimePaymentFailure', code: ScheduleOneTimePaymentFailureCode }
    | { __typename: 'ScheduleOneTimePaymentSuccess', id: string, name: string }
   };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod:
    | { __typename: 'SetDefaultPaymentMethodFailure', code: SetDefaultPaymentMethodFailureCode }
    | { __typename: 'SetDefaultPaymentMethodSuccess', id: string, isDefault: boolean }
   };

export type VerifyBankAccountInformationMutationVariables = Exact<{
  input: VerifyBankAccountInput;
}>;


export type VerifyBankAccountInformationMutation = { __typename?: 'Mutation', verifyBankAccountInformation:
    | { __typename: 'VerifyBankAccountInformationFailure', code: VerifyBankAccountFailureCode }
    | { __typename: 'VerifyBankAccountInformationSuccess', gatewayTokenId: string, authTransactionId: string }
   };

export type VerifyCreditCardInformationMutationVariables = Exact<{
  input: VerifyCreditCardInformationInput;
}>;


export type VerifyCreditCardInformationMutation = { __typename?: 'Mutation', verifyCreditCardInformation:
    | { __typename: 'VerifyCreditCardInformationFailure', code: VerifyCreditCardFailureCode }
    | { __typename: 'VerifyCreditCardInformationSuccess', gatewayTokenId: string, authTransactionId: string, network: CardNetwork }
   };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'MeType', id: string, email: string, userType: UserType, firstName?: string | null, lastName?: string | null, profileName?: string | null, memberId?: string | null, providerId?: string | null, practiceId?: string | null, messagingMailboxId?: string | null, providerImageUrl?: string | null, sfUsername?: string | null } };


export const EnableMyAutoPayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableMyAutoPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableMyAutoPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnableMyAutoPaySuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoPay"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnableMyAutoPayFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<EnableMyAutoPayMutation, EnableMyAutoPayMutationVariables>;
export const MyMemberInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfOldestUnpaidInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<MyMemberInfoQuery, MyMemberInfoQueryVariables>;
export const AddBankAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddBankAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddBankAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addBankAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddBankAccountSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddBankAccountFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<AddBankAccountMutation, AddBankAccountMutationVariables>;
export const AddCreditCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCreditCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCreditCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCreditCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddCreditCardSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddCreditCardFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<AddCreditCardMutation, AddCreditCardMutationVariables>;
export const EditBankAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditBankAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditBankAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editBankAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EditBankAccountSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last6"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"nameOnAccount"}},{"kind":"Field","name":{"kind":"Name","value":"isHSA"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EditBankAccountFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<EditBankAccountMutation, EditBankAccountMutationVariables>;
export const EditCreditCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditCreditCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditCreditCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editCreditCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EditCreditCardSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"nameOnCard"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"isHSA"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EditCreditCardFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<EditCreditCardMutation, EditCreditCardMutationVariables>;
export const MaximumPaymentAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaximumPaymentAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maximumPaymentAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<MaximumPaymentAmountQuery, MaximumPaymentAmountQueryVariables>;
export const MyNextPaymentDueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyNextPaymentDue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myNextPaymentDue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}}]}}]}}]} as unknown as DocumentNode<MyNextPaymentDueQuery, MyNextPaymentDueQueryVariables>;
export const MyPaymentTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPaymentTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MyPaymentTransactionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPaymentTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"accountKind"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"accountSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"filteredCount"}}]}}]}}]} as unknown as DocumentNode<MyPaymentTransactionsQuery, MyPaymentTransactionsQueryVariables>;
export const MySavedPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MySavedPaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MySavedPaymentMethodsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mySavedPaymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MySavedPaymentMethodsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SavedCreditCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"nameOnCard"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"isHSA"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SavedBankAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last6"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"nameOnAccount"}},{"kind":"Field","name":{"kind":"Name","value":"isHSA"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MySavedPaymentMethodsFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<MySavedPaymentMethodsQuery, MySavedPaymentMethodsQueryVariables>;
export const MyUpcomingPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyUpcomingPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myUpcomingPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"accountKind"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"accountSuffix"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}}]}}]} as unknown as DocumentNode<MyUpcomingPaymentsQuery, MyUpcomingPaymentsQueryVariables>;
export const RemoveBankAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveBankAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveBankAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBankAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveBankAccountSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveBankAccountFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveBankAccountMutation, RemoveBankAccountMutationVariables>;
export const RemoveCreditCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCreditCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveCreditCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCreditCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveCreditCardSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveCreditCardFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveCreditCardMutation, RemoveCreditCardMutationVariables>;
export const ScheduleOneTimePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScheduleOneTimePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleOneTimePaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleOneTimePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleOneTimePaymentSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleOneTimePaymentFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduleOneTimePaymentMutation, ScheduleOneTimePaymentMutationVariables>;
export const SetDefaultPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetDefaultPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setDefaultPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetDefaultPaymentMethodSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetDefaultPaymentMethodFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const VerifyBankAccountInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyBankAccountInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyBankAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyBankAccountInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyBankAccountInformationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayTokenId"}},{"kind":"Field","name":{"kind":"Name","value":"authTransactionId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyBankAccountInformationFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<VerifyBankAccountInformationMutation, VerifyBankAccountInformationMutationVariables>;
export const VerifyCreditCardInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyCreditCardInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCreditCardInformationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyCreditCardInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCreditCardInformationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayTokenId"}},{"kind":"Field","name":{"kind":"Name","value":"authTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"network"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyCreditCardInformationFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<VerifyCreditCardInformationMutation, VerifyCreditCardInformationMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userType"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"practiceId"}},{"kind":"Field","name":{"kind":"Name","value":"messagingMailboxId"}},{"kind":"Field","name":{"kind":"Name","value":"providerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sfUsername"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;